import { Component, ElementRef, Input, AfterViewInit, OnInit, OnChanges, ViewChild, SimpleChanges } from '@angular/core';

import { ApiError, AuthService, BaseFilterCollapse, BaseFilterCollapseService, ConfigService, MessageService } from '../../../core';
import { ConfigEmpresa } from '../../configuracoes/app/empresa';
import { TituloReceberVencidosFilter } from './titulo-receber-vencidos-filter';
import { tituloReceberSituacoes } from '../situacao/titulo-receber-situacao';
import { Pessoa } from '../../pessoa';
import { Representante } from '../../pessoa/representante';

@Component({
    selector: 'sgt-titulo-receber-vencidos-filter-collapse',
    templateUrl: './titulo-receber-vencidos-filter-collapse.component.html',
    styleUrls: ['./titulo-receber-vencidos-filter-collapse.component.less']
})
export class TituloReceberVencidosFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    configEmpresa: ConfigEmpresa;
    isRepresentante: boolean;

    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;

    @Input() filter: TituloReceberVencidosFilter;
    situacoes = tituloReceberSituacoes;

    // Multiselects
    isFirstChangeLocaisFaturamentosMultiselect = true;

    constructor(private authService: AuthService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private configService: ConfigService,
                private messageService: MessageService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isRepresentante = this.authService.isRepresentante();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
      if (!this.isCollapsedInDefault) {
        jQuery(this.filterCollapse.nativeElement).css('display', 'none');
      }
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
    }

    /** Ao alterar os locais de faturamentos */
    onChangeLocaisFaturamentos() {
        if (this.isFirstChangeLocaisFaturamentosMultiselect) {
            this.isFirstChangeLocaisFaturamentosMultiselect = false;
            return;
        }
        this.isFilterDirty = true;
    }

    /** Ao alterar o cliente/pessoa no typeahead */
    onTypeaheadChangeCliente(pessoa: Pessoa) {
        if (pessoa) {
            this.filter.idPessoa = pessoa.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idPessoa = null;
        }
    }

    /** Ao alterar o representante no typeahead */
    onTypeaheadChangeRepresentante(representante: Representante) {
        if (representante) {
            this.filter.idRepresentante = representante.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idRepresentante = null;
        }
    }
}
